export default { icon: {
    padding: "10px 10px 10px 20px",
  },
  
  rightName:{
    display:"flex",
    marginBottom: "3px",
    borderBottom:"1px dashed #515151",
    paddingBottom: "3px",
    alignItems: "center",
    "& span":{
      marginLeft:"auto",
      borderRadius:"50px",
      width: "20px",
      height: "20px",
      minWidth:"20px",
      textAlign: "center",
      verticalAlign: "middle",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& svg":{
        fontSize:"12px",
      },
    }
  },
  rightStatusRed:{
    background:"red"
  },
  rightStatusGreen:{
    background:"green"
  },
  buttons: {
    "&:hover": {
      opacity: ".8",
      color: "#fff",
      background: "#0C853E",
    },
    boxShadow: "none",
    background: " #0C853E",
    border: "1px solid #0C853E",
    lineHeight: "31px",
    fontSize: "14px",
    minWidth: "40px",
    margin: "15px",
    padding: "0",
    height: "40px",
    borderRadius: "4px",
  },
  paperwrap: {
    position: "relative",
    height: "100vh",
    width: "calc(100% - 20px)",
    background: "none",
    boxShadow: "none",
  },
  muListWrap: {
    padding: "10px",
    height: " calc(100% - 58px)",
    overflow: "auto",
    position: "absolute",
    width: "100%",
    top: "0",
    overflowX: "hidden",
    background: " #353535",
  },
  muDetailWrap: {
    display: "flex",
    padding: "8px 0",
    borderBottom: "1px solid #5a5a5a",
    alignItems: "center",
  },
  muSeperator:{
    display:"inline-block",
    verticalAlign: "top",
    marginRight: "5px",
    lineHeight: "1",
    fontSize: "0.7em",
  },
  muLabels: {
    width: "40%",
    textTransform: "uppercase",
    color: "#dcdcdc",
    fontSize: "0.7em",
    display: "inline-block",
    verticalAlign: "top",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth:"250px"
  },
  muDetails: {
    width: "80%",
    display: "inline-block",
    verticalAlign: "top",
    fontSize: "0.75em",
    wordBreak:"break-word",
    "& a":{
      color: "#26B70B !important",
      "&:hover":{
      color: "#00FC08 !important",
      }
    },
    "& .MuiCircularProgress-colorPrimary":{
      color: "white",
      width: "20px !important",
      height:" 20px !important",
    },
    "& .MuiChip-root":{
      fontSize:"0.9em  !important",
      "$ .MuiChip-label":{
        maxWidth: "160px",
      }
    }
  },
  disFlex: {
    display: "flex",
    borderBottom: "1px solid #5a5a5a",
    borderRadius: "0",
    alignItems: "center",
    "& .helpAddMargin":{
      // margin: "6px"
    }
  },
  noData: {
    top: "50%",
    width: "100%",
    // bottom: "0",
    fontSize: "12px",
    position: "absolute",
    textAlign: "center",
    right: "0",
    left: "0",
    "& svg": {
      display: "block",
      margin: "0 auto",
    },
  },
  sideBar: {
    position: "relative",
    height: "100vh",
    background: " #181818",
  },
  muTitle: {
    color: "#fff",
    fontSize: "0.88em",
    fontWeight: "500",
    width: "-webkit-fill-available",
    width:"100%",
    padding: "10px 15px 10px 30px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    margin: "0",
    whiteSpace: "nowrap",
  },
  muSubTitle: {
    color: "#cac9c9",
    fontSize: "0.85em",
    fontWeight: "600",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "block",
  },

  userProfileImageSidebar:{
    padding: "20px",
    maxWidth: "100px",
    minWidth: "100px",
    minHeight: "100px",
    margin:"0 auto",
    "& .MuiAvatar-root":{
      width:"100px",
      height:"100px",
      borderRadius: "50px !important",
    },
    "& img":{
      width:"100%",
      height:"auto",
    },
  },

  trackTabs:{
    "& .MuiBox-root":{
      padding:"0 !important"
    }
  },
  trackTabsHeader:{
    background:"#242424",
    "& .MuiTabs-indicator":{
      backgroundColor:"#0C853E !important"
    },
    
  },
  trackTags:{
    marginBottom: "15px",
    borderBottom: "1px solid #6b6b6b",
    paddingBottom: "5px",
    "& label":{
      display:"block",
      margin:"10px 0 10px 0",
      color: "#DEDEDE",
      textTransform:"uppercase",
      fontSize:"0.7em",
    },
    "& .MuiChip-root": {
      margin: "0px 5px 8px 0",
      background: "#272727",
    border: "none",
    color:"#ffcb00",
    height: "inherit",
    minHeight: "30px",
    fontSize: "11px",
    "& .MuiChip-label":{
      whiteSpace: "pre-wrap",
      wordBreak: "break-all",
      padding:"5px 12px"
    }
  },
  "& p":{
    fontSize:"11px",
  }
  },
  trackTabsNoData:{
   padding:"20px",
   textAlign:"center",
  },
  trackTabsNoDataText:{
    fontSize: "14px",
    padding: "10%",
    display: "block",
  },
  artworkDiv:{
    "& img":{
      borderRadius:"3px"
    }
  },
  emptyArtwork:{
    height:"160px !important",
  },
  trackTabs:{
    "& .MuiBox-root":{
      padding:"0 !important",
    }
  },
  historyItem:{
    borderBottom:"1px solid #656565",  
    padding:"0 0 5px 0",  
    marginBottom: "10px",
    textAlign:"left",
    "& p":{
      textAlign:"left", 
      fontSize:"12px"
    }
  },
  actionName:{
    color:"#fff",
    fontSize:"12px !important",
    margin:"0px  0 8px 0",
    background: "#00608e",
    display: "inline-block",
    borderRadius: "3px",
    padding: "4px 6px",
  },
  objectName:{
    fontSize:"12px",
    "& ul":{
      padding:"0",
      margin:"0",
      "& li":{
        padding:"0",
        margin: "5px 0",
        listStyle:"none",
        fontSize:"12px",
        lineHeight:"19px",
        "& .clearanceValueLabel":{
          margin: "8px 0 5px 0",
          display: "block",
          "& > div":{
            width:"20px",
            height:"20px",
            margin: "0 5px 0 0",
            borderRadius: "50px",
            display: "inline-block",
            verticalAlign: "middle",
          }
        },
        "& > span":{
          fontSize:"12px",
        }
      }
    },
    "& .clearanceValueLabel":{
      maxWidth:"inherit",
    }
  },
  changedDate:{
    fontSize:"0.8em",
    color:"#FCE939",
    margin:"4px 0 8px 0",
    padding: "0",
  },
  userName:{
    fontSize:"0.75em",
    margin:"8px 0 0 0",
    padding: "0",
    textAlign:"left"
  },
  trackData:{
    fontSize:"12px",
    color:"#e3e3e3",
    textTransform:"uppercase",
    margin:"0px 0 8px 0",
    display:"block",
    borderBottom: "1px solid #6b6b6b",
    paddingBottom: "8px",
  },
  trackHistoryWrap:{
    background:"#474747",
    padding:"10px",
    borderRadius: "5px",
    margin:"5px 0 10px 0",
  },

  sidebarDataContainer: {
    width: "100%",
    background: "none",
    boxShadow: "none",
    overflow: "auto",
    position: "absolute",
    background: "none",
    marginTop: "0",
    background: "#353535",
    "&.popOutDisplay":{
      position:"relative"
    }
  },
  sidebarWrappedData: {
    padding: "20px 30px",
    overflow: "auto",
    overflowX: "hidden",
    background: "#1f364d !important",
  },

  sidebarWrappedDataDark: {
    padding: "10px",
    overflow: "auto",
    overflowX: "hidden",
    background: "#353535",
  },
  popOutBlock:{
    background:"#424242",
    textAlign:"center",
    flex: "1",
    "& button":{
      fontSize:"12px",
      margin:"5px 0 12px 10px",
      background:"#0c853e",
      "&:hover":{
        background:"#04923F",
      },
      "& svg":{
        fontSize:"1.5em",
        marginRight:"5px"
      }
    },

  },
  buildRuleRow:{
    border: "1px solid #737373",
    marginBottom: "5px",
    borderRadius: "3px",
    margin: "10px 0",
    padding: "10px",
},
  buildEditorBlock:{
     fontSize:"12px",
    borderRadius: "3px",
    margin: "10px 0px 10px 0px",
    position: "absolute",
    height: "calc(100% - 459px)",
    overflow: "auto",
    right: "0",
    padding: "20px",
    left: "0",   
    "& > div":{
      padding:"0 20px",
    }
  },

 ruleTriggerLabel:{
    color: "#FCE939",
    display: "inline-block",
    borderRadius: "3px",
    margin: "0 0 5px 0",
    textDecoration: "underline",
    display: "block",
    clear: "left",
    fontSize:"0.8em",
  },
  ruleNotes:{
    borderTop: "1px solid #807f7f",
    marginTop: "10px",
    paddingTop: "10px",
  },
  conditionTag:{
    "& > span":{
      margin:"6px 0 5px 0",
    }
  },

buildRuleContainer:{
    width:"100%",
    textAlign:"center",
    marginTop:"15px",
  },
  ruleDetails:{
    display:"flex",
    borderBottom: "1px solid #807f7f",
    marginBottom: "10px",
    alignItems: "baseline",
  },
  ruleData:{
    width: "100%",
    marginRight: "10px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "12px",
    "& > span":{
      fontSize: "12px",
      margin: "0 10px 0 0px",
    }
  },
  popOutBlock:{
    background:"#424242",
    textAlign:"center",
    flex: "1",
    "& button":{
      fontSize:"12px",
      margin:"7px 11px 7px 0",
      background:"#0c853e",
      display:"block",
      padding:"13px 10px",
      width:"100%",
      "&:hover":{
        background:"#04923F",
      },
      "& svg":{
        fontSize:"2em",
        display:"block",
      margin:"0 auto 5px auto"
      },
      "& img":{
        display:"block",
      margin:"0 auto"
      }
    },
  },
}